import React from 'react'

import {Card, withStyles, Typography} from 'material-ui'

import Hero, {HeroContent} from './Hero'
import MainNav from './MainNav'
import SignupForm from './SignupForm'
import TitledPage from './TitledPage'

const styles = theme => ({
    hero: {
        zIndex: 0,
        position: "relative",
        backgroundColor: "#0972CF",
        // background: 'url(/img/stripes.png)',
        minHeight: 120,
        padding: "0 20px",
        paddingBottom: 120,
        '&::before': {
            content: `''`,
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            background: 'url(/img/stripes.png) center repeat',
            backgroundSize: "40em 40em",
            opacity: 0.1,
        }
    },
    heroForeground: {

    },
    card: {
        position: 'relative',
        top: -120,
        zIndex: 1,
        [theme.breakpoints.up('sm')]: {
          width: 600,
        },
        margin: "0 auto",
        padding: 20,
    },
})

export const Contact = withStyles(styles)(
    ({classes, history, ...props}) => (
        <TitledPage title="Carefol.io | sign up">
            <Hero classes={{root: classes.hero}}>
                <MainNav/>
                <HeroContent className={classes.heroContent}>
                    <Typography align="center" component="h1">Sign up</Typography>
                    <br/>
                    <Typography align="center" component="p">
                        We're glad you've decided to give Carefolio a try!
                    </Typography>
                    <Typography align="center" component="p">
                        Please enter the information requested below, and then check your
                        email to complete your sign-up.
                    </Typography>
                    <br/>
                    <br/>
                </HeroContent>
            </Hero>
            <Card className={classes.card}>
                <SignupForm history={history}/>
            </Card>
        </TitledPage>
    )
)

export default Contact


// WEBPACK FOOTER //
// ./src/components/Signup.jsx